import { Modal } from "@next-platform/client-common-spicy-ui";
import { navigateRoute, useAppDispatch, useAppSelector } from "@next-platform/client-common-core";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import useAuth from "@/services/useAuth";

import LoginContent from "./LoginContent";

interface OverlayLoginProps {
  onClose: () => void;
}

export const OverlayLogin = ({ onClose }: OverlayLoginProps) => {
  const isOpen = useAppSelector((state) => state?.navigation?.isOverlayLogin);
  const { isAuthenticated } = useAuth();
  const storedPath = useAppSelector((state) => state?.navigation?.path);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleClose = useCallback(() => {
    onClose();
    if (!isAuthenticated && storedPath) {
      navigate(storedPath);
      dispatch(navigateRoute(""));
    }
  }, [onClose, isAuthenticated, storedPath, navigate, dispatch]);

  return (
    <Modal open={isOpen} onOpenChange={handleClose} backdrop="blur" className="bg-gray-3">
      <LoginContent />
    </Modal>
  );
};
